// utils/metrics.ts
import { WIDGET_API } from './constants';
import { addPwPrefixToBaseUrl } from './pwContext';
/**
 * Parses current URL and state to provide configuration for metrics reporting.
 */
export const getReportContext = () => {
  const { href = '', search = '', pathname = '' } = window?.location || {};
  const params = new URLSearchParams(search);
  const isLLA = pathname.includes('/LLA');

  let sessionId = params.get('session_id') || params.get('cashier_session_id') || params.get('sessionId') || '';

  // For LLA pages, session ID is in the URL path, not query params
  if (isLLA) {
    const llaSegment = pathname.split('/').find((segment) => segment.startsWith('LLA'));
    if (llaSegment) {
      sessionId = llaSegment;
    }
  }

  const isWithdrawal = href.includes('withdrawal') && !href.includes('reject-withdrawal');
  const flow = isWithdrawal ? 'payouts' : 'payments';

  const baseMetricsUrl = `${WIDGET_API}/${flow}/metrics`;
  const requestUrl = addPwPrefixToBaseUrl(baseMetricsUrl);

  return {
    sessionId,
    requestUrl,
    flow,
    isLLA,
  };
};
